


























import click2Top from "@/common/directives/click2Top";
import { Vue, Component, Watch } from "vue-property-decorator";
import QNav from "./qNav.vue";
import QFooter from "./qFooter.vue";
import { namespace } from "vuex-class";

const authStore = namespace("Auth");

@Component({
  name: "AdminLayout",
  directives: {
    click2Top,
  },
  components: {
    QFooter,
    QNav,
  },
})
export default class AdminLayout extends Vue {
  @authStore.Action
  fetchCurrentUser!: () => void;

  @authStore.Getter
  public getRole!: string;

  @authStore.Getter
  public getLoggingUser!: any;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any, oldValue: any) {
    if (newValue && oldValue && newValue.name !== oldValue.name) {
      this.changedRoute++;
    }
    // this.checkRole();
  }
  public changedRoute = 1;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public closeNavigate() {
    (this.$refs.top as Element).classList.remove("open");
  }

  get classPage(): string[] {
    this.changedRoute; // hack to re-computed
    const initalClass = ["mb__admin"];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    return initalClass;
  }
}
